import { formatDate, formatDateISO } from '@helpers/date';
import { ReactComponent as SvgCalendar } from '@img/icons/date-icon.svg';
import { ReactComponent as SvgPin } from '@img/icons/location-icon.svg';
import FernBanner from '!file-loader!@img/card-bg.jpg';
import FernBannerFeatured from '!file-loader!@img/card-featured-bg.jpg';
import React from 'react';
import S from './EventCard.styles';
const EventCard = ({ id, date, favourite = false, featured, location, isLoggedIn = false, tag, title, url, }) => {
    return (React.createElement(S.Container, { "data-featured": featured },
        React.createElement(S.BgArea, null,
            featured ?
                React.createElement(S.Background, { alt: 'Plant image', draggable: false, loading: "lazy", role: "presentation", src: FernBannerFeatured })
                :
                    React.createElement(S.Background, { alt: 'Plant image', draggable: false, loading: "lazy", role: "presentation", src: FernBanner }),
            React.createElement(S.Overlay, null)),
        React.createElement(S.Link, { href: url, title: title },
            React.createElement(S.ContentWrapper, null,
                featured && React.createElement(S.Badge, null, "Featured"),
                React.createElement(S.Tag, null, tag),
                React.createElement(S.Title, null, title),
                React.createElement(S.Date, { dateTime: formatDateISO(date) },
                    React.createElement(SvgCalendar, null),
                    React.createElement("span", null, formatDate(date))),
                !!location && React.createElement(S.Location, null,
                    React.createElement(SvgPin, null),
                    React.createElement("span", null, location)),
                React.createElement(S.FavouriteToggle, { id: id, initialValue: favourite, isLoggedIn: isLoggedIn })))));
};
export default EventCard;
